import { Capacitor } from '@capacitor/core';
import { ConfigService } from '@posx/core';
import { ServicesBuilder } from './setup';
import { logInfo } from './logger';

type CheckResult = Record<string, unknown>;

export const checkBasic = async (): Promise<CheckResult> => ({
  platform: Capacitor.getPlatform(),
  network_connected: navigator.onLine,
});

// Row counts expose a half-synced database, e.g. items at 0 leaves the menu empty
export const checkDatabase = async (): Promise<CheckResult> => {
  const factory = ServicesBuilder.getInstance();
  // getService polls until the db is connected; getDiagnosticsService throws instead of waiting
  await factory.getService(ConfigService);
  const { tables, totalCount } = await factory.getDiagnosticsService().getTableStats();
  return { totalCount, tables: tables.map(({ name, count }) => ({ name, count })) };
};

const CHECKS: [string, () => Promise<CheckResult>][] = [
  ['basic', checkBasic],
  ['database', checkDatabase],
];

export const runHealthCheck = async (): Promise<void> => {
  try {
    const entries = await Promise.all(
      CHECKS.map(async ([name, check]): Promise<[string, CheckResult]> =>
        [name, await check().catch(e => ({ error: e?.message ?? String(e) }))])
    );
    logInfo('posx_health_check', Object.fromEntries(entries));
  } catch {}
};
